export default "__VITE_ASSET__d22330d2__"